<!--
  - Copyright (c) 2020. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <router-view></router-view>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { mapGetters, mapActions } from "vuex";
import {
  mqDesktop,
  mqFullhd,
  mqWidescreen,
  mqMobile,
  mqTablet,
  BREAKPOINTS
} from "../util/media-query";

export default {
  components: {
    // PageHeader,
    // PageFooter
  },
  computed: {
    ...mapGetters({
      locale: "language/locale"
    })
  },
  methods: {
    ...mapActions({
      setActiveMediaQuery:
        "mediaQuery/setActive" /** @see MediaQueriesStore.setActive */
    }),
    switchToMobile(e) {
      if (e.matches) {
        this.setActiveMediaQuery(BREAKPOINTS.MOBILE);
      }
    },
    switchToTablet(e) {
      if (e.matches) {
        this.setActiveMediaQuery(BREAKPOINTS.TABLET);
      }
    },
    switchToDesktop(e) {
      if (e.matches) {
        this.setActiveMediaQuery(BREAKPOINTS.DESKTOP);
      }
    },
    switchToWidescreen(e) {
      if (e.matches) {
        this.setActiveMediaQuery(BREAKPOINTS.WIDESCREEN);
      }
    },
    switchToFullhd(e) {
      if (e.matches) {
        this.setActiveMediaQuery(BREAKPOINTS.FULLHD);
      }
    },
    ...mapActions({ loadNotifications: "notifications/load" })
  },
  mounted() {
    mqMobile.addListener(this.switchToMobile);
    mqTablet.addListener(this.switchToTablet);
    mqDesktop.addListener(this.switchToDesktop);
    mqWidescreen.addListener(this.switchToWidescreen);
    mqFullhd.addListener(this.switchToFullhd);
    this.loadNotifications();
  },
  destroyed() {
    mqMobile.removeListener(this.switchToMobile);
    mqTablet.removeListener(this.switchToTablet);
    mqDesktop.removeListener(this.switchToDesktop);
    mqWidescreen.removeListener(this.switchToWidescreen);
    mqFullhd.removeListener(this.switchToFullhd);
  },
  metaInfo() {
    return {
      title: "BZUK",
      titleTemplate: "%s | BZUK",
      meta: [{ charset: "utf-8" }],
      htmlAttrs: {
        lang: this.locale,
        amp: false
      }
    };
  }
};
</script>

<style lang="scss">
@import "../styles/index";
</style>
